import activityBonusConfig from "./en-US/activityBonusConfig";
import activityBonusHistory from "./en-US/activityBonusHistory";
import activityBonusRecord from "./en-US/activityBonusRecord";
import adjustAppConfig from "./en-US/adjustAppConfig";
import agentApproval from "./en-US/agentApproval";
import agentApprovalHistory from "./en-US/agentApprovalHistory";
import agentCashbackAdmin from "./en-US/agentCashbackAdmin";
import agentDetails from "./en-US/agentDetails";
import agentReport from "./en-US/agentReport";
import airdropConfig from "./en-US/airdropConfig";
import betActivity from "./en-US/betActivity";
import betOrder from "./en-US/betOrder";
import betReport from "./en-US/betReport";
import bonusApproval from "./en-US/bonusApproval";
import bonusRecord from "./en-US/bonusRecord";
import checkinRecord from "./en-US/checkinRecord";
import cashTransferRecord from "./en-US/cashTransferRecord";
import component from "./en-US/component";
import configAboutAdmin from "./en-US/configAboutAdmin";
import configLeftMenuAdmin from "./en-US/configLeftMenuAdmin";
import dailyRebateAdmin from "./en-US/dailyRebateAdmin";
import dailyReports from "./en-US/dailyReports";
import depositRecord from "./en-US/depositRecord";
import emailMarketing from "./en-US/emailMarketing";
import messageAdmin from "./en-US/messageAdmin";
import freeSpinConfig from "./en-US/freeSpinConfig";
import freeSpinRecord from "./en-US/freeSpinRecord";
import gameActions from "./en-US/gameActions";
import gamesManage from "./en-US/gamesManage";
import gemExchangeMallAdmin from "./en-US/gemExchangeMallAdmin";
import gemExchangeTagsAdmin from "./en-US/gemExchangeTagsAdmin";
import gemGoodsAdmin from "./en-US/gemGoodsAdmin";
import gemGoodsTypeAdmin from "./en-US/gemGoodsTypeAdmin";
import globalHeader from "./en-US/globalHeader";
import inviteBoxAdmin from "./en-US/inviteBoxAdmin";
import kFactor from "./en-US/kFactor";
import loginHistory from "./en-US/loginHistory";
import ltv from "./en-US/ltv";
import luckWheelDailyStatisticsReport from "./en-US/luckWheelDailyStatisticsReport";
import luckydrawConfig from "./en-US/luckydrawConfig";
import luckywheelRecord from "./en-US/luckywheelRecord";
import memberDeposits from "./en-US/memberDeposits";
import menu from "./en-US/menu";
import operationRecord from "./en-US/operationRecord";
import orderList from "./en-US/orderList";
import pages from "./en-US/pages";
import paymentPlatformAdmin from "./en-US/paymentPlatformAdmin";
import pixelsManagement from "./en-US/pixelsManagement";
import pwa from "./en-US/pwa";
import pwaDeviceList from "./en-US/pwaDeviceList";
import pwaNotificationList from "./en-US/pwaNotificationList";
import pwaNotificationTasks from "./en-US/pwaNotificationTasks";
import rolesAdmin from "./en-US/rolesAdmin";
import realTimeRebateAdmin from "./en-US/realTimeRebateAdmin";
import redemptionCodeConfig from "./en-US/redemptionCodeConfig";
import redemptionCodeRecord from "./en-US/redemptionCodeRecord";
import redPacketRain from "./en-US/redPacketRain";
import reliefFundActivity from "./en-US/reliefFundActivity";
import retentionRate from "./en-US/retentionRate";
import settingDrawer from "./en-US/settingDrawer";
import settings from "./en-US/settings";
import tagsAdmin from "./en-US/tagsAdmin";
import taskAdmin from "./en-US/taskAdmin";
import topupList from "./en-US/topupList";
import userDepositBonusAdmin from "./en-US/userDepositBonusAdmin";
import userList from "./en-US/userList";
import userPromotionsAdmin from "./en-US/userPromotionsAdmin";
import userReport from "./en-US/userReport";
import userRisk from "./en-US/userRisk";
import userVipAdmin from "./en-US/userVipAdmin";
import walletChangeList from "./en-US/walletChangeList";
import walletRecord from "./en-US/walletRecord";
import withdrawApproval from "./en-US/withdrawApproval";
import redPacketRecord from "./en-US/redPacketRecord";
import userDetails from "./en-US/userDetails";
import layout from "./en-US/layout";

export default {
  "navBar.lang": "Languages",
  "layout.user.link.help": "Help",
  "layout.user.link.privacy": "Privacy",
  "layout.user.link.terms": "Terms",
  "app.preview.down.block": "Download this page to your local project",
  "app.welcome.link.fetch-blocks": "Get all block",
  "app.welcome.link.block-list":
    "Quickly build standard, pages based on `block` development",
  ...layout,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...orderList,
  ...topupList,
  ...gamesManage,
  ...gameActions,
  ...withdrawApproval,
  ...betReport,
  ...betOrder,
  ...walletChangeList,
  ...depositRecord,
  ...ltv,
  ...kFactor,
  ...retentionRate,
  ...bonusRecord,
  ...userList,
  ...userRisk,
  ...memberDeposits,
  ...checkinRecord,
  ...cashTransferRecord,
  ...freeSpinRecord,
  ...freeSpinConfig,
  ...airdropConfig,
  ...pwaDeviceList,
  ...pwaNotificationList,
  ...pwaNotificationTasks,
  ...luckywheelRecord,
  ...walletRecord,
  ...userReport,
  ...tagsAdmin,
  ...redemptionCodeConfig,
  ...redemptionCodeRecord,
  ...activityBonusConfig,
  ...activityBonusRecord,
  ...luckWheelDailyStatisticsReport,
  ...luckydrawConfig,
  ...loginHistory,
  ...operationRecord,
  ...agentApproval,
  ...agentApprovalHistory,
  ...adjustAppConfig,
  ...agentDetails,
  ...agentReport,
  ...userVipAdmin,
  ...dailyRebateAdmin,
  ...userDepositBonusAdmin,
  ...userPromotionsAdmin,
  ...gemGoodsTypeAdmin,
  ...gemGoodsAdmin,
  ...gemExchangeMallAdmin,
  ...gemExchangeTagsAdmin,
  ...agentCashbackAdmin,
  ...inviteBoxAdmin,
  ...configAboutAdmin,
  ...taskAdmin,
  ...configLeftMenuAdmin,
  ...pixelsManagement,
  ...rolesAdmin,
  ...paymentPlatformAdmin,
  ...emailMarketing,
  ...messageAdmin,
  ...bonusApproval,
  ...activityBonusHistory,
  ...redPacketRain,
  ...betActivity,
  ...reliefFundActivity,
  ...realTimeRebateAdmin,
  ...redPacketRecord,
  ...userDetails,
  ...dailyReports,
};
